/* import __COLOCATED_TEMPLATE__ from './modal-footer-close.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./modal-footer-close.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));